import {Component} from "react";

export class SellToWebTableHeaderComponent extends Component {
    render() {
        return this.props.children;
    }
}